// @ts-nocheck
import * as React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import API from './API/API';
import { SetAdmin, SetAdminRole, SetEmail, setAppTextColor, setAppTheme, setFirstName, setID, setIsLoggedIn, setIsLoggedOut, setLastName, setProfilePhoto } from './Redux/Reducers/appState';
import { authFetch } from './utils/authFetch';
import { getSavedThemePreference } from './utils/themePreference';
import NewsSkeleton from './screens/Home/Skeleton';
import DeferredMount from './components/Performance/DeferredMount';
const Home = React.lazy(() => import('./screens/Home/Home'));
const CreateAccount = React.lazy(() => import('./screens/Account/CreateAccount/CreateAccount'));
const AccountHome = React.lazy(() => import('./screens/Account/AccountHome'));
const SuccessPage = React.lazy(() => import('./screens/Account/SuccessPage'));
const Login = React.lazy(() => import('./screens/Account/Login/Login'));
const AdminPanel = React.lazy(() => import('./screens/AdminPanel/AdminPanel'));
const CreateNews = React.lazy(() => import('./screens/AdminPanel/CreateNews/CreateNews'));
const NewsDetails = React.lazy(() => import('./screens/Home/News/NewsDetails.js/NewsDetails'));
const NewsDetailsUsepParams = React.lazy(() => import('./screens/Home/News/NewsDetails.js/NewsDetailsUseParam'));
const NewsController = React.lazy(() => import('./screens/AdminPanel/News/NewsController'));
const Profile = React.lazy(() => import('./screens/Account/Profile/Profile'));
const UserMessages = React.lazy(() => import('./screens/Account/Messages/UserMessages'));
const Bookmarks = React.lazy(() => import('./screens/Account/Bookmarks/Bookmarks'));
const Donate = React.lazy(() => import('./screens/Donate/Donate'));
const ForgotPassword = React.lazy(() => import('./screens/Account/Login/ForgotPassword'));
const Otp = React.lazy(() => import('./screens/Account/Login/Otp'));
const ResetPassword = React.lazy(() => import('./screens/Account/Login/resetPassword'));
const Sports = React.lazy(() => import('./screens/Sports/Sports'));
const Jobs = React.lazy(() => import('./screens/Jobs/Jobs'));
const GovernmentJobs = React.lazy(() => import('./screens/Jobs/GovernmentJobs/GovernmentJobs'));
const Web3 = React.lazy(() => import('./screens/Web3/Web3'));
const ActionSuccessPage = React.lazy(() => import('./screens/AdminPanel/News/actionSucces'));
const VisitorController = React.lazy(() => import('./screens/AdminPanel/Visitors/VisitorController'));
const MessageController = React.lazy(() => import('./screens/AdminPanel/Messages/MessageController'));
const MostLikedNewsController = React.lazy(() => import('./screens/AdminPanel/MostLikedNews/MostLikedNewsController'));
const UserController = React.lazy(() => import('./screens/AdminPanel/Users/UserController'));
const DonationWallets = React.lazy(() => import('./screens/AdminPanel/DonationWallets/DonationWallets'));
const NotFound = React.lazy(() => import('./screens/NotFound/NotFound'));
const About = React.lazy(() => import('./screens/About/About'));
const PrivacyPolicy = React.lazy(() => import('./screens/Legal/PrivacyPolicy'));
const TermsAndConditions = React.lazy(() => import('./screens/Legal/TermsAndConditions'));
const CookiePolicy = React.lazy(() => import('./screens/Legal/CookiePolicy'));
const Disclaimer = React.lazy(() => import('./screens/Legal/Disclaimer'));
const DMCA = React.lazy(() => import('./screens/Legal/DMCA'));
const EditorialPolicy = React.lazy(() => import('./screens/Legal/EditorialPolicy'));
const AIDisclosure = React.lazy(() => import('./screens/Legal/AIDisclosure'));
const CommunityGuidelines = React.lazy(() => import('./screens/Legal/CommunityGuidelines'));
const Contact = React.lazy(() => import('./screens/Legal/Contact'));
const SubscriptionTerms = React.lazy(() => import('./screens/Legal/SubscriptionTerms'));
const RefundPolicy = React.lazy(() => import('./screens/Legal/RefundPolicy'));
const Pricing = React.lazy(() => import('./screens/Subscriptions/Pricing'));
const AccountSubscription = React.lazy(() => import('./screens/Subscriptions/AccountSubscription'));
const UserDashboard = React.lazy(() => import('./screens/UserDashboard/UserDashboard'));
const CreatorDashboard = React.lazy(() => import('./screens/Creator/Dashboard'));
const CreatorEconomy = React.lazy(() => import('./screens/AdminPanel/CreatorEconomy/CreatorEconomy'));
const AiTools = React.lazy(() => import('./screens/AdminPanel/AiTools/AiTools'));
const AuditLogs = React.lazy(() => import('./screens/AdminPanel/AuditLogs/AuditLogs'));
const PHawkSettings = React.lazy(() => import('./screens/AdminPanel/PHawkSettings/PHawkSettings'));
const GovernmentJobScraper = React.lazy(() => import('./screens/AdminPanel/PHawkSettings/GovernmentJobScraper/GovernmentJobScraper'));
const AdminSubscriptions = React.lazy(() => import('./screens/AdminPanel/Subscriptions/AdminSubscriptions'));
const GovernmentJobsAdmin = React.lazy(() => import('./screens/AdminPanel/GovernmentJobs/GovernmentJobsAdmin'));
const PHawkAssistant = React.lazy(() => import('./components/PHawkAssistant/PHawkAssistant'));
const BottomNavigationBar = React.lazy(() => import('./components/layout/BottomNavigationBar'));

const RouteFallback = () => <NewsSkeleton />;
const PROTECTED_PATH_PREFIXES = [
  "/dashboard",
  "/account",
  "/profile",
  "/messages",
  "/bookmarks",
  "/creator",
  "/account/subscription",
  "/PIDControllerX",
];

const HIDE_BOTTOM_NAV_PREFIXES = [
  "/PIDControllerX",
  "/creator",
  "/createaccount",
  "/login",
  "/forgotpassword",
  "/otp",
  "/resetpassword",
  "/successpage",
  "/actionsuccesspage",
];

const shouldShowBottomNav = (pathname = "") =>
  !HIDE_BOTTOM_NAV_PREFIXES.some((prefix) => String(pathname || "").startsWith(prefix));

const  App = () => {
  const location = useLocation();
  const appTheme = useSelector((data)=>data.appState.appTheme)
  const appFontSize = useSelector((data)=>data.appState.appFontSize)
  const dispatch = useDispatch();
  const showBottomNav = shouldShowBottomNav(location.pathname);

  React.useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }

    const savedThemePreference = getSavedThemePreference();
    const isDark = savedThemePreference === "dark";
    dispatch(setAppTheme(isDark ? "#0b1118" : "white"));
    dispatch(setAppTextColor(isDark ? "white" : "black"));
  }, [dispatch]);

  React.useEffect(() => {
    const isDark = appTheme === "#0b1118";
    document.documentElement.setAttribute("data-theme", isDark ? "dark" : "light");
  }, [appTheme]);

  React.useEffect(() => {
    const fontSizeMap = {
      small: "14px",
      medium: "16px",
      large: "18px",
    };

    document.documentElement.style.fontSize = fontSizeMap[appFontSize] || fontSizeMap.medium;
  }, [appFontSize]);

  React.useEffect(() => {
    document.body.classList.toggle("has-bottom-nav", showBottomNav);

    return () => {
      document.body.classList.remove("has-bottom-nav");
    };
  }, [showBottomNav]);

  React.useEffect(() => {
    if (typeof window === "undefined") {
      return undefined;
    }

    const currentPath = window.location.pathname || "/";
    const shouldLoadImmediately = PROTECTED_PATH_PREFIXES.some((prefix) => currentPath.startsWith(prefix));
    let timeoutId = 0;
    let idleId = 0;
    let cancelled = false;

    const syncSession = async () => {
      try {
        const response = await authFetch(`${API.BASE_URL}/session`);
        const data = await response.json();

        if (data.authenticated && data.user) {
          dispatch(setIsLoggedIn(true));
          dispatch(setIsLoggedOut(false));
          dispatch(setID(data.user.id));
          dispatch(setFirstName(data.user.firstName || ""));
          dispatch(setLastName(data.user.lastName || ""));
          dispatch(SetEmail(data.user.email || ""));
          dispatch(SetAdmin(data.user.isAdmin || 0));
          dispatch(SetAdminRole(data.user.adminRole || "user"));
          dispatch(setProfilePhoto(data.user.profilephoto || ""));
          return;
        }
      } catch (error) {
        console.error(error);
      }

      dispatch(setIsLoggedIn(false));
      dispatch(setIsLoggedOut(true));
      dispatch(setID(-1));
      dispatch(setFirstName(""));
      dispatch(setLastName(""));
      dispatch(SetEmail("guess@guess.com"));
      dispatch(SetAdmin(0));
      dispatch(SetAdminRole("user"));
      dispatch(setProfilePhoto(""));
    };

    const runSync = () => {
      if (cancelled) {
        return;
      }

      syncSession();
    };

    if (shouldLoadImmediately) {
      runSync();
      return undefined;
    }

    if (typeof window.requestIdleCallback === "function") {
      idleId = window.requestIdleCallback(runSync, { timeout: 1500 });
    } else {
      timeoutId = window.setTimeout(runSync, 350);
    }

    return () => {
      cancelled = true;
      if (idleId && typeof window.cancelIdleCallback === "function") {
        window.cancelIdleCallback(idleId);
      }
      if (timeoutId) {
        window.clearTimeout(timeoutId);
      }
    };
  }, [dispatch]);

  return (
    <div className="app-shell">
    <React.Suspense fallback={<RouteFallback />}>
    <Routes> 
        <Route path="*" element={<Home />} />
        <Route path="/home" index element={<Home />} />
        <Route path="/web3"  element={<Web3 />} />
        <Route path="/tech"  element={<Web3 />} />
        <Route path="/sports"  element={<Sports />} />
        <Route path="/jobs"  element={<Jobs />} />
        <Route path="/jobs/government-jobs"  element={<GovernmentJobs />} />
        <Route path="/crypto"  element={<Web3 />} />
        <Route path="/pricing"  element={<Pricing />} />
        <Route path="/account"  element={<AccountHome />} />
        <Route path="/account/profile"  element={<Profile />} />
        <Route path="/account/saved-posts"  element={<Bookmarks />} />
        <Route path="/account/reading-history"  element={<UserDashboard />} />
        <Route path="/account/email-alerts"  element={<AccountSubscription />} />
        <Route path="/account/payment-history"  element={<AccountSubscription />} />
        <Route path="/account/notifications"  element={<AccountSubscription />} />
        <Route path="/account/settings"  element={<Profile />} />
        <Route path="/createaccount"  element={<CreateAccount />} />
        <Route path="/login"  element={<Login />} />
        <Route path="/successpage" element={<SuccessPage />} />
        <Route path="/PIDControllerX"  element={<AdminPanel />} />
        <Route path="/PIDControllerX/dashboard"  element={<AdminPanel />} />
        <Route path="/admin"  element={<AdminPanel />} />
        <Route path="/admin/dashboard"  element={<AdminPanel />} />
        <Route path="/admin/ai-tools"  element={<AiTools />} />
        <Route path="/admin/ai-tools/phawk-settings"  element={<PHawkSettings />} />
        <Route path="/admin/ai-tools/phawk-settings/government-job-scraper"  element={<GovernmentJobScraper />} />
        <Route path="/PIDControllerX/users"  element={<UserController />} />
        <Route path="/PIDControllerX/createnews"  element={<CreateNews />} />
        <Route path="/readnews"  element={<NewsDetails />} />
        <Route path="/readnews/:id"  element={<NewsDetailsUsepParams />} />
        <Route path="/news/:id"  element={<NewsDetailsUsepParams />} />
        <Route path="/share/:id"  element={<NewsDetailsUsepParams />} />
        <Route path="/PIDControllerX/adminnews"  element={<NewsController />} />
        <Route path="/PIDControllerX/adminnews/:id/edit"  element={<CreateNews />} />
        <Route path="/PIDControllerX/messages"  element={<MessageController />} />
        <Route path="/PIDControllerX/most-liked-news"  element={<MostLikedNewsController />} />
        <Route path="/PIDControllerX/creator-economy"  element={<CreatorEconomy />} />
        <Route path="/PIDControllerX/audit-logs"  element={<AuditLogs />} />
        <Route path="/admin/audit-logs"  element={<AuditLogs />} />
        <Route path="/PIDControllerX/p-hawk-settings"  element={<PHawkSettings />} />
        <Route path="/PIDControllerX/subscriptions"  element={<AdminSubscriptions />} />
        <Route path="/PIDControllerX/government-jobs"  element={<GovernmentJobsAdmin />} />
        <Route path="/admin/government-jobs"  element={<GovernmentJobsAdmin />} />
        <Route path="/profile"  element={<Profile />} />
        <Route path="/dashboard"  element={<UserDashboard />} />
        <Route path="/account/subscription"  element={<AccountSubscription />} />
        <Route path="/messages"  element={<UserMessages />} />
        <Route path="/bookmarks"  element={<Bookmarks />} />
        <Route path="/creator"  element={<CreatorDashboard />} />
        <Route path="/creator/create-news"  element={<CreateNews />} />
        <Route path="/creator/news/:id/edit"  element={<CreateNews />} />
        <Route path="/donate"  element={<Donate />} />
        <Route path="/forgotpassword"  element={<ForgotPassword />} />
        <Route path="/otp/page"  element={<Otp />} />
        <Route path="/resetpassword"  element={<ResetPassword />} />
        <Route path="/actionsuccesspage"  element={<ActionSuccessPage />} />
        <Route path="/PIDControllerX/visitorcontroller"  element={<VisitorController />} />
        <Route path="/PIDControllerX/donation-wallets"  element={<DonationWallets />} />
        <Route path="/about"  element={<About />} />
        <Route path="/privacypolicy"  element={<PrivacyPolicy />} />
        <Route path="/privacy-policy"  element={<PrivacyPolicy />} />
        <Route path="/terms"  element={<TermsAndConditions />} />
        <Route path="/terms-and-conditions"  element={<TermsAndConditions />} />
        <Route path="/subscription-terms"  element={<SubscriptionTerms />} />
        <Route path="/refund-policy"  element={<RefundPolicy />} />
        <Route path="/cookie-policy"  element={<CookiePolicy />} />
        <Route path="/disclaimer"  element={<Disclaimer />} />
        <Route path="/dmca"  element={<DMCA />} />
        <Route path="/editorial-policy"  element={<EditorialPolicy />} />
        <Route path="/ai-disclosure"  element={<AIDisclosure />} />
        <Route path="/community-guidelines"  element={<CommunityGuidelines />} />
        <Route path="/contact"  element={<Contact />} />
        <Route path="/notfound"  element={<NotFound />} />
    </Routes>
    <DeferredMount timeoutMs={1800}>
      <React.Suspense fallback={null}>
        <PHawkAssistant />
      </React.Suspense>
    </DeferredMount>
    {showBottomNav ? (
      <React.Suspense fallback={null}>
        <BottomNavigationBar />
      </React.Suspense>
    ) : null}
    </React.Suspense>
    </div>
  );
}

export default App;
